module.exports = __webpack_public_path__ + "static/media/leftIMG.bc4ef98c.jpg";